
import { Component, HostBinding, Output, EventEmitter, AfterViewInit, NgZone, Injectable, Inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { slideInAnimation } from './animations';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
declare const gapi: any;
declare const $: any;
declare const Tawk_API: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    slideInAnimation
    // animation triggers go here
  ]
})

@Injectable({
  providedIn: 'root'
})
export class AppComponent implements AfterViewInit {
  proxyedSignInSuccess;
  userAuthToken;
  userDisplayName;
  user;
  name;
  imageurl;
  email;
  id_token;
  id;
  message;
  Tawk_API;
  logon = false;
  public onGoogleLoginSuccess = (loggedInUser) => {
    console.log({ loggedInUser })
    this.user = loggedInUser;

    var profile = loggedInUser.getBasicProfile();
    var id_token = loggedInUser.getAuthResponse().id_token;

    Object.assign(this, {
      id: profile.getId(),
      name: profile.getName(),
      imageurl: profile.getImageUrl(),
      email: profile.getEmail(),
      id_token: id_token
    })

    Tawk_API.visitor = {
      name: profile.getName(),
      email: profile.getEmail()
    };


    ///*
    var xhr = new XMLHttpRequest();

    xhr.open('POST', 'https://api.studydse.net/api/verify.php');

    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.withCredentials = true;
    xhr.onload = () => {
      console.log(xhr.responseText);
      this.message = xhr.responseText;
      if (this.message == 'Welcome!') {


        this.logon = true;


      }
      Tawk_API.setAttributes({
        'name': profile.getName(),
        'email': profile.getEmail()

      }, function (error) {
        console.log(error)
      });

    };
    xhr.send('idtoken=' + id_token);

    //  */
  }
  constructor(
    public dialog: MatDialog,
    private zone: NgZone) {
    this.zone.run(() => {
      this.proxyedSignInSuccess = $.proxy(this.onGoogleLoginSuccess, this);
    });
  }

  title = 'studydse';
  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }
  signOut() {
    var auth2 = gapi.auth2.getAuthInstance();
    auth2.signOut().then(function () {
      console.log('User signed out.');
    });
  }
  @Output() notify = new EventEmitter();


  ginit() {
    gapi.auth2.init({
      'client_id': '397904555791-hs6g1d3k00kfk42ngftn6ba5ced1bc2o'
    })
  }

  ngAfterViewInit() {


    gapi.load('auth2,signin2', this.ginit);
    gapi.signin2.render('google_signin_button', {
      'onsuccess': (user) => this.zone.run(() => this.onGoogleLoginSuccess(user)),
      'theme': 'light'
    })
  }

  openTrialDialog() {

    const dialogRef = this.dialog.open(TrialDialog, {
      width: '500px',
      data: { name: "", pw: "" }

    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result) {

        var xhr = new XMLHttpRequest();

        xhr.open('POST', '/api/dummy_login.php');
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.onload = () => {
          this.logon = true;
        };
        xhr.send();

      }

    });



  }



}

@Component({
  selector: 'trial-dialog',
  templateUrl: './trial-dialog.html',
})

export class TrialDialog {
  constructor(@Inject(MAT_DIALOG_DATA) public data) { }


}